import { List } from 'immutable';
import BaseList from 'records/BaseList';
import { mapToRecords } from 'records/Opco';
import {
  OPCO_ASYNC_START,
  OPCO_RESET_STATE,
  OPCO_SET_DATA,
  OPCO_ASYNC_ERROR,
} from 'actions/opco';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [OPCO_ASYNC_START]: state => state.merge({
    loading: true,
    errorMessage: null,
  }),
  [OPCO_SET_DATA]: (state, action) => state.merge({
    loading: false,
    data: mapToRecords(action.payload.opcos),
  }),
  [OPCO_ASYNC_ERROR]: (state, action) => state.merge({
    loading: false,
    errorMessage: action.payload.error,
  }),
  [OPCO_RESET_STATE]: () => initialState,
};

export default function opco(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
